module.exports = __webpack_public_path__ + "img/ic_shift_type.99a12b5d.svg";